import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { AppInfo } from './app/global/environment';
import { ClientList, EnvironmentList } from './app/global/environment/environment.type';
import { getClientFromUrl } from './app/shared/utils/utils';

// IMPORTANT: This shoudl never be committed or merged with a value.
const localClient: { client: ClientList; environment: EnvironmentList } | undefined = undefined;

function setBrowserTabIcon(clientFolder: string) {
  const iconHref = clientFolder === 'ao' ? '/branding/ao-favicon.ico' : '/favicon.ico';
  const iconType = 'image/x-icon';

  let iconLink = document.querySelector<HTMLLinkElement>('link[rel~="icon"]');

  if (!iconLink) {
    iconLink = document.createElement('link');
    iconLink.rel = 'icon';
    document.head.appendChild(iconLink);
  }

  iconLink.type = iconType;
  iconLink.href = iconHref;
}

export async function bootstrap() {
  try {
    const clientInfo = localClient ?? getClientFromUrl();

    if (!clientInfo) {
      throw new Error('Client not found');
    }

    const { client, environment } = clientInfo;
    const clientFolder = client.toLowerCase();
    let envFile = environment.toLowerCase();

    if (envFile === 'production') {
      envFile = 'prod';
    }

    if (envFile === 'uat') {
      envFile = 'qa';
    }

    const module = await import(`./environments/gb/${clientFolder}/environment.${envFile}.ts`);
    const environmentConfig = module.environment || module.default;

    if (!environmentConfig) {
      throw new Error(`Environment config not found for ${client} in ${environment}`);
    }

    AppInfo._setEnvironmentValue(environmentConfig);

    if (environment === 'dev') {
      console.log(`Bootstrapping for client: ${client}, environment: ${environment}`);
    }

    document.querySelector('html')?.classList.add(client.toLowerCase());
    setBrowserTabIcon(clientFolder);

    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
  } catch (error) {
    console.error('Bootstrap failed:', error);
  }
}
